import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import FloorDetail from '../../components/floor/FloorDetail';

import { translate } from 'react-i18next';
import { defaultRejectHandler } from '../../utils/utility';
import { createFloor } from '../../redux/floor/floor_actions';

class FloorCreateModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.floorDetail = undefined;
  }

  onSaveHandler() {
    const newFloor = this.floorDetail.getWrappedInstance().getWrappedInstance().getFloorData();
    this.props.createFloor(newFloor);
  }

  render() {
    const { isCreating, errorMessage, createFloor, building, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('create floor')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FloorDetail
            building={building}
            ref={ref => (this.floorDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isCreating && !this.props.isCreated && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="floor-submit-create"
            disabled={!isSubmittable || isCreating}
            onClick={() => this.onSaveHandler()}
          >
            {isCreating ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  errorMessage: state.floor.errorMessage,
  isCreating: state.floor.isCreating,
});

const mapDispatchToProps = (dispatch, { building }) => ({
  createFloor: floor =>
    defaultRejectHandler(
      dispatch(createFloor(floor.name, building.id, floor.description)),
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(FloorCreateModal),
);



// WEBPACK FOOTER //
// ./src/modal/floor/FloorCreateModal.js